import { cn } from '@/components/TailwindComponents/lib/utils';

interface ReadOnlyFieldProps {
  label: string;
  value?: string | number | null;
  className?: string;
  masked?: boolean;
}

const ReadOnlyField = ({
  label,
  value,
  className,
  masked = false,
}: ReadOnlyFieldProps) => {
  const displayValue = (() => {
    if (value === null || value === undefined || value === '') {
      return '-';
    }

    if (masked && typeof value === 'string' && value.length > 4) {
      // Mask all but last 4 characters
      return '•'.repeat(value.length - 4) + value.slice(-4);
    }

    return String(value);
  })();

  return (
    <div className={cn('flex flex-col gap-1', className)}>
      <label className="text-xs font-medium text-gray-600 dark:text-gray-300">
        {label}
      </label>
      <div className="text-sm text-gray-900 dark:text-gray-100 font-medium">
        {displayValue}
      </div>
    </div>
  );
};

export default ReadOnlyField;
